export const Bhumika = require("./bhumika.png");
export const CvPDF = require("./Bhoomika_Agola_Frontend_Developer.pdf");
// export const Projectimage = require("./React-App.png");
export const Projectimage1 = require("./protfolio/Cognopia.png");
export const Projectimage2 = require("./protfolio/DesignPax.webp");
export const Projectimage3 = require("./protfolio/Dragonfly-Designs.png");
export const Projectimage4 = require("./protfolio/LoveDevani-com.webp");
export const Projectimage5 = require("./protfolio/Economic-Analysis.png");
export const Projectimage6 = require("./protfolio/Eugene-Oregon.png");
export const Projectimage7 = require("./protfolio/PODTECH.png");
export const Projectimage8 = require("./protfolio/Home-Clima.png");
export const Projectimage9 = require("./protfolio/Home-FieldX.webp");
export const Projectimage10 = require("./protfolio/Ian-Altman.png");
export const Projectimage11 = require("./protfolio/Pure-Real-Estate.webp");
export const Projectimage12 = require("./protfolio/Optimus-India.png");
export const Projectimage13 = require("./protfolio/Rise-TV.webp");
export const Projectimage14 = require("./protfolio/SimpleTherapy.png");
export const Projectimage15 = require("./protfolio/C6-EPD-Home.webp");
export const Projectimage16 = require("./protfolio/privateLINE.webp");
export const Projectimage17 = require("./protfolio/Queryloom.png");
export const Projectimage18 = require("./protfolio/Pabau.png");
export const Projectimage19 = require("./protfolio/AACAE.webp");
export const Projectimage20 = require("./protfolio/PBX.webp");
export const Projectimage21 = require("./protfolio/Macrotech-Kiosk.webp");
export const Projectimage22 = require("./protfolio/Console.webp");
export const Projectimage23 = require("./protfolio/PMS.webp");
